module.exports = __webpack_public_path__ + "img/V71.1cbbb7a4.jpg";